<template>
  <el-dialog
    :title="$t('store::album::edit_设置商品条件')"
    :visible.sync="visible"
    :append-to-body="appendToBody"
    :close-on-click-modal="false"
    width="690px"
  >
    <p class="title">{{ $t('store::album::edit_条件') }}</p>

    <el-radio-group v-model="condition.conditionType">
      <div style="margin-bottom: 24px">
        <el-radio :label="1">
          {{ $t('store::album::edit_所有条件') }}
        </el-radio>
        <span class="tip">({{ $t('store::album::edit_所有条件tip') }})</span>
      </div>
      <div style="margin-bottom: 24px">
        <el-radio :label="2">
          {{ $t('store::album::edit_任一条件') }}
        </el-radio>
        <span class="tip">({{ $t('store::album::edit_任一条件tip') }})</span>
      </div>
    </el-radio-group>

    <div class="condition">
      <div v-for="(i, index) in condition.conditions" :key="index" class="condition-item">
        <el-select
          style="width: 110px"
          v-model="i.filterObj"
          @change="
            () => {
              i.condition = ''
              i.value = ''
            }
          "
        >
          <el-option
            v-for="item in conditionList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select style="width: 110px; margin: 0 8px" v-model="i.filterType" @change="i.value = ''">
          <el-option
            v-for="item in getTypeList(i.filterObj)"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-cascader
          :options="categoryOpt"
          :props="{ label: 'name', value: 'id', children: 'childrens', checkStrictly: true }"
          class="input-item"
          v-model="i.target"
          v-if="i.filterObj === 2"
          style="width: 360px; margin-right: 8px"
        ></el-cascader>
        <el-select v-model="i.target" v-else-if="i.filterObj === 4" style="width: 360px; margin-right: 8px">
          <el-option :key="item.id" :label="item.tagName" :value="item.id" v-for="item in tagOptions"></el-option>
        </el-select>
        <el-input v-else v-model="i.target" style="width: 360px; margin-right: 8px"></el-input>
        <i class="add-btn" :class="index === 0 ? 'el-icon-plus' : 'el-icon-delete'" @click="handle(index)"></i>
      </div>
    </div>

    <p class="title" style="margin-top: 32px">
      {{ $t('store::album::edit_特殊过滤规则') }}
      <span class="tip">( {{ $t('store::album::edit_特殊过滤规则tip') }})</span>
    </p>

    <div>
      <el-select style="width: 110px" v-model="special.type">
        <el-option label="SPU" value=""></el-option>
      </el-select>
      <el-select style="width: 110px; margin-left: 8px" v-model="special.condition">
        <el-option :label="$t('store::album::edit_包含')" value=""></el-option>
      </el-select>
      <el-input
        type="textarea"
        :rows="4"
        style="margin-top: 16px"
        v-model="condition.filterSpuIds"
        :placeholder="$t('store::album::edit_tip')"
      ></el-input>
    </div>
    <div slot="footer" class="dialog-footer" style="text-align: center">
      <el-button size="small" @click="visible = false">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button size="small" type="primary" :loading="loading" @click="sumbit">
        {{ $t('system::common::btn::confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getProdCategories, getTagList } from '@/server/product'
export default {
  props: {
    // 不是新增 就是编辑
    value: {
      type: Boolean,
      default: false,
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      visible: this.value,
      loading: false,
      type: 0,
      condition: {
        conditions: [{ filterObj: '', filterType: '', target: '' }],
        filterSpuIds: '',
        conditionType: 1,
      },
      special: {
        type: '',
        condition: '',
      },
      conditionList: [
        { label: this.$t('store::album::edit_商品名称'), value: 1 },
        { label: this.$t('store::album::edit_商品类目'), value: 2 },
        { label: this.$t('store::album::edit_商品库存'), value: 3 },
        { label: this.$t('store::album::edit_商品标签'), value: 4 },
        { label: this.$t('store::album::edit_商品售价'), value: 5 },
      ],
      categoryOpt: [],
      tagOptions: [],
    }
  },
  mounted() {
    this.getCategory()
    this.getTagList()
  },
  methods: {
    getTagList() {
      getTagList({
        page_size: 100,
        page_num: 1,
      }).then(res => {
        if (res.data.code === this.$code) {
          this.tagOptions = res.data.data.items
        }
      })
    },
    getCategory() {
      getProdCategories({
        page_num: 1,
        page_size: 100,
      }).then(res => {
        if (res.data.success) {
          this.categoryOpt = res.data.data.items.map((item, i) => {
            if (item.childrens.length) {
              item.childrens = this.reverseData(item, [])
            } else {
              if (item.childrens) delete item.childrens
            }

            return {
              ...item,
            }
          })
        }
      })
    },
    reverseData(data, arr = []) {
      return data.childrens.map(item => {
        if (item.childrens && item.childrens.length) {
          arr.push(data.id)
          item.childrens = this.reverseData(item, JSON.parse(JSON.stringify(arr)))
          return {
            parentIds: arr,
            ...item,
          }
        } else {
          arr.push(data.id)
          if (item.childrens) delete item.childrens
          return {
            parentIds: arr,
            ...item,
          }
        }
      })
    },
    getTypeList(val) {
      let list = []
      if (val === 3 || val === 5) {
        list = [
          { label: this.$t('store::album::edit_大于'), value: 8 },
          { label: this.$t('store::album::edit_等于'), value: 3 },
          { label: this.$t('store::album::edit_小于'), value: 7 },
        ]
      } else if (val === 4) {
        list = [{ label: this.$t('store::album::edit_等于'), value: 3 }]
      } else {
        list = [
          { label: this.$t('store::album::edit_包含'), value: 1 },
          { label: this.$t('store::album::edit_不包含'), value: 2 },
          { label: this.$t('store::album::edit_等于'), value: 3 },
          { label: this.$t('store::album::edit_不等于'), value: 4 },
          { label: this.$t('store::album::edit_开头为'), value: 5 },
          { label: this.$t('store::album::edit_结尾为'), value: 6 },
        ]
      }
      return list
    },
    handle(index) {
      if (index === 0) {
        this.condition.conditions.push({ filterObj: '', filterType: '', target: '' })
      } else {
        this.condition.conditions.splice(index, 1)
      }
    },
    sumbit() {
      const conditions = this.condition.conditions
      for (let i = 0; i < conditions.length; i++) {
        if (!conditions[i].filterObj || !conditions[i].filterType || !conditions[i].target) {
          this.$message.error(this.$t('store::album::edit_请填写完整条件'))
          return
        }
      }
      if (this.condition.filterSpuIds.length) {
        let bool = this.condition.filterSpuIds.split(',').every(el => {
          return Number(el) == el
        })
        if (!bool) {
          this.$message.error(this.$t('store::album::edit_请按规则输入SPU'))
          return
        }
      }
      this.$emit('save', this.condition)
      this.visible = false
    },
  },
  watch: {
    visible(val) {
      this.$emit('input', val)
      if (val) {
        this.condition.conditions =
          this.form.conditions && this.form.conditions.length
            ? this.form.conditions
            : [{ filterObj: '', filterType: '', target: '' }]
        this.condition.filterSpuIds = this.form.filterSpuIds
        this.condition.conditionType = this.form.conditionType
      } else {
        this.condition.conditions = [{ filterObj: '', filterType: '', target: '' }]
        this.condition.filterSpuIds = ''
        this.condition.conditionType = 1
      }
    },
    value(val) {
      this.visible = val
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: center;
}
.title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 16px;
}
.tip {
  font-size: 13px;
  color: #999;
  font-weight: normal;
  margin-left: 8px;
}
.condition-item + .condition-item {
  margin-top: 16px;
}
.add-btn {
  display: inline-block;
  width: 40px;
  height: 40px;
  background: #f0f0f0;
  border-radius: 5px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  cursor: pointer;
}
.el-icon-plus {
  color: #0560fd;
}
.el-icon-delete {
  color: #ff0022;
}
</style>
